<template>
  <vs-navbar v-model="activeItem" class="nabarx">
    <vs-navbar-title><img src="../../assets/img/logo.png"/></vs-navbar-title>

    <vs-spacer></vs-spacer>

    <vs-navbar-item index="0">
      <router-link to="/">{{$t('nav.catalogs')}}</router-link>
    </vs-navbar-item>
    <vs-navbar-item index="1">
      <router-link to="/categories">{{$t('nav.categories')}}</router-link>
    </vs-navbar-item>
    <vs-navbar-item index="2">
      <router-link to="/menu">{{$t('nav.menu')}}</router-link>
    </vs-navbar-item>
    <vs-navbar-item index="2">
      <router-link to="/account">{{$t('nav.account')}}</router-link>
    </vs-navbar-item>
    <vs-navbar-item index="3">
      <a @click="logout">{{$t('nav.logout')}}</a>
    </vs-navbar-item>
  </vs-navbar>
</template>

<script>
export default {
  name: 'component-header',
  data: () => ({
    activeItem: 0
  }),

  methods: {
    logout() {
      localStorage.clear()
      location.href = '/'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
header {
  background: #170c4f !important;
  padding: 10px;
  margin-bottom: 20px;
  
  img{
    max-width: 40px;
  }
  
  h3,
  a {
    color: white;
  }
}
</style>

<style lang="scss">
header{
  .vs-con-items{
    width: 100%;
  }
}
</style>